require.register("javascripts/html5-game/Preloader", function(exports, require, module){
  var HTML5Game = HTML5Game || {};

HTML5Game.Preloader = function (game) {

};

HTML5Game.Preloader.prototype = {
  preload: function () {
    //  This is where we create sprites from the assets we loaded in Boot.js
    /*Images*/
    this.game.load.image('sky', TGA.IMG_FP + 'sky.png');
    this.game.load.image('ground', TGA.IMG_FP + 'platform.png');
    this.game.load.image('star', TGA.IMG_FP + 'star.png');
    this.game.load.spritesheet('dude', TGA.IMG_FP + 'dude.png', 32, 48);
  },
  create: function () {
    this.state.start('Game');
  }
};

module.exports = HTML5Game.Preloader;


  
});

